$(document).ready(function() {
	
	if($(".viewSloveniaMobile").length > 0){
		showTables();
		$("#wikiComponentSlovenia").on('change', function(){
			showTables();
		});
	}
		
});


function showTables(){
	$("#wikiComponentSlovenia option").each(function(index, elem){
		var id_table = $(elem).val();
		var table = $('#'+id_table);
		if($(table).hasClass("in")){
			$(table).removeClass("in");
		}
	});
	
	var id_table = $("#wikiComponentSlovenia option:selected").val();
	$('#'+id_table).addClass("in");
	
	if($("#wikiComponentSlovenia option").length < 2){
	     $(".show-slovenia-mobile").hide();   
	}
}
